import { useState } from "react";

export const useSesionSelection = () => {
    const [selectedIds, setSelectedIds] = useState([]);

    const toggleRow = (id) => {
        setSelectedIds((prev) =>
            prev.includes(id)
                ? prev.filter((x) => x !== id)
                : [...prev, id]
        );
    };

    const handleRowClick = (sesion, event) => {
        const target = event.target;
        if (
            target.closest("button") ||
            target.closest("input") ||
            target.closest("textarea") ||
            target.closest("a")
        ) {
            return;
        }
        toggleRow(sesion.id);
    };

    const clearSelection = () => {
        setSelectedIds([]);
    };

    return {
        selectedIds,
        setSelectedIds,
        toggleRow,
        handleRowClick,
        clearSelection,
    };

};
